import {
  Http
} from '@/model/Http.js'
export default class douYin extends Http {
  // 抖音数据
  getData(data) {
    const url = '/movie/open/open-dy-data-analysis/search-total'
    return this.postAjaxByDouYin(url, {
      ...data
    })
  }
  // 抖音数据列表
  getDataList(data) {
    const url = '/movie/open/open-dy-data-analysis/search-open'
    return this.postAjaxByDouYin(url, {
      ...data
    })
  }
  videoExportData(data) {
    const url = '/open/dy/open-data-summary/video-detail-export'
    return this.postAjaxByMiniExport(url, data)
  }



  // 团购核销列表导出(快手)
  ksVerifyOrderExport(data) {
    const url = '/open/open/verify/order/export-ks'
    return this.postAjaxByMiniExport(url, data)
  }
  // 团购核销统计(快手)
  ksVerifyTotal(data) {
    const url = '/open/open/verify/order/stat-ks'
    return this.postAjaxByDouYin(url,data)
  }
  // 团购核销列表搜索(快手)
  ksVerifyOrderSearch(data) {
    const url = '/open/open/verify/order/list-ks'
    return this.postAjaxByDouYin(url,  {...data})
  }



  // 抖音数据列表1111
  liveOrderList(data) {
    const url = '/open/open/user/tk-reference-order'
    return this.postAjaxByDouYin(url, {
      ...data
    })
  }
  // 获取抖音数据列表数
  getOrderListNum(data) {
    const url = '/open/open/user/tk-reference-order-stat'
    return this.postAjaxByDouYin(url, data)
  }
  // 抖音直播导出
  liveExportData(data) {
    const url = '/open/dy/open-data-summary/live-detail-export'
    return this.postAjaxByMiniExport(url, data)
  }
  // 订单导出
  liveOrderExportData(data) {
    const url = '/open/open/user/tk-reference-order-export'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取达人表格
  getMasterPage(data) {
    const url = '/open/open/dy-user-relation/search'
    return this.postAjaxByDouYin(url, data)
  }
  // 获取达人表格快手
  getMasterPageKs(data) {
    const url = '/open/open/ks-user-relation/search'
    return this.postAjaxByDouYin(url, data)
  }
  // 获取分销达人表格
  getAgencyMasterPage(data) {
    const url = '/open/open/dy-user-relation/master-search'
    return this.postAjaxByDouYin(url, data)
  }
  // 获取分销达人表格快手
  getAgencyMasterPageKs(data) {
    const url = '/open/open/ks-user-relation/master-search'
    return this.postAjaxByDouYin(url, data)
  }
  // 设置收款账户
  setMasterAccount(data) {
    const url = '/open/open/dy-user-relation/set-account'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置销售溢价
  setMasterpremium(data) {
    const url = '/open/open/dy-user-relation/set-price-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置销售溢价快手
  setMasterpremiumKs(data) {
    const url = '/open/open/ks-user-relation/set-price-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置佣金比例
  setMasterCommissionRate(data) {
    const url = '/open/open/dy-user-relation/set-commission-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置佣金比例快手
  setMasterCommissionRateKs(data) {
    const url = '/open/open/ks-user-relation/set-commission-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取抖音码
  getMasterQrcode(data) {
    const url = '/open/open/dy-user-relation/get-qrcode'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取快手码
  getMasterQrcodeKs(data) {
    const url = '/open/open/ks-user-relation/get-qrcode'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取已配置的比例
  getMasterRelation(data) {
    const url = '/open/open/dy-user-relation/get-self'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 判断是否有权限
  getPermission(data) {
    const url = '/open/dy/open-data-summary/permission'
    return this.postAjaxByDouYin(url, data, true)
  }


  // 获取交易数据
  getTransactionData(data) {
    const url = '/open/dy/open-data-summary/transaction-data'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取直播列表
  getLiveDetail(data) {
    const url = '/open/dy/open-data-summary/live-detail'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取视频列表
  getVideoDetail(data) {
    const url = '/open/dy/open-data-summary/video-detail'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 待结佣导出
  unpaidCommissionExport(data) {
    const url = '/open/dy/open-data-summary/export-search'
    return this.postAjaxByMiniExport(url, data)
  }
  // 获取待结佣分页
  getUnpaidCommissionPage(data) {
    const url = '/open/dy/open-data-summary/search'
    return this.postAjaxByDouYin(url, data)
  }
  // 已结佣导出
  alreadyEngagedExport(data) {
    const url = '/open/dy/open-data-summary/export-search-settle'
    return this.postAjaxByMiniExport(url, data)
  }
  // 已结佣分页
  getAlreadyEngagedPage(data) {
    const url = '/open/dy/open-data-summary/search-settle'
    return this.postAjaxByDouYin(url, data)
  }
  // 设置结算分佣详情
  setSettleCommission(data) {
    const url = '/open/open/user/set-commission'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置结算分佣详情
  setKsSettleCommission(data) {
    const url = '/open/open/user/set-ks-commission'
    return this.postAjaxByDouYin(url, data, true)
  }

  // 获取结算分佣详情
  querySettleCommission(data) {
    const url = '/open/open/user/go-set-commission'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 结佣管理 - 自动结佣失败条数
  querySettleFailCount(data) {
    const url = '/open/dy/open-data-summary/auto-fail-count'
    return this.postAjaxByDouYin(url, data, true)
  }


  // 银行卡名单
  getBankList(data) {
    const url = '/open/open/open-bank/bank-list'
    return this.postAjaxByDouYin(url, data)
  }

  // 根据卡号识别开户行
  recognizeBank(data) {
    const url = '/open/open/open-bank/distinguish'
    return this.postAjaxByDouYin(url, data, true)
  }

  // 开发平台前台，抖音-结算管理
  batchApplySettle(data) {
    const url = '/open/dy/open-data-commission/batch-apply-settle'
    return this.postAjaxByDouYin(url, data,)
  }

  // 开发平台前台，抖音-结算管理提交
  batchSettle(data) {
    const url = '/open/dy/open-data-commission/batch-settle'
    return this.postAjaxByDouYin(url, data)
  }

  // 获取佣金设置记录
  getRateChangeLog(data) {
    const url = '/open/open/dy-user-relation/rate-change-log'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取佣金设置记录快手
  getRateChangeLogKs(data) {
    const url = '/open/open/ks-user-relation/rate-change-log'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 分销代理列表
  getComRatioLog(data) {
    const url = '/open/open/user/com-ratio-log'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 取消绑定
  cancelBindMaster(data) {
    const url = '/open/open/dy-user-relation/cancel-bind'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 取消绑定快手
  cancelBindMasterKs(data) {
    const url = '/open/open/ks-user-relation/cancel-bind'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 代理结佣管理列表
  getAgencySettlePage(data) {
    const url = '/open/open/open-dy-data-summary/search'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 订单导出
  userDataExport(data) {
    const url = '/open/open/open-dy-data-summary/export-search'
    return this.postAjaxByMiniExport(url, data)
  }
  // 代理结佣 - 查询计算
  settlementSearch(data) {
    const url = '/open/open/open-dy-data-summary/search-calc-settle'
    return this.postAjaxByDouYin(url, data)
  }
  // 代理结佣 - 所有代理
  getAgentAllList(data) {
    const url = '/open/open/open-dy-user-app/search'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 代理结佣 - 所有代理
  getAgentAllListKs(data) {
    const url = '/open/open/open-ks-user-app/search'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 代理结佣 - 提交结算
  onSettlementSubmit(data) {
    const url = '/open/open/open-dy-data-summary/commit-settle'
    return this.postAjaxByDouYin(url, data,)
  }
  getAgentList(data) {
    const url = '/open/open/user/search'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置代理佣金比例
  setAgentRate(data) {
    const url = '/open/open/user/save-tk-comm-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取默认代理佣金比例
  setDefaultAgentRate(data) {
    const url = '/open/open/user/modify-default-rate'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取默认代理佣金比例
  setDefaultAgentRateKs(data) {
    const url = '/open/open/user/modify-default-rate-ks'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取代理注册信息
  getAgentRegister(data) {
    const url = '/open/open/user/register-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 获取代理注册信息
  getAgentRegisterKs(data) {
    const url = '/open/open/user/ks-register-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置给达人的联系方式
  setReferInfo(data) {
    const url = '/open/open/dy-user-relation/set-refer-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 设置给达人的联系方式快手
  setReferInfoKs(data) {
    const url = '/open/open/ks-user-relation/set-refer-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 给达人的联系方式
  queryReferInfo(data) {
    const url = '/open/open/dy-user-relation/refer-info'
    return this.postAjaxByDouYin(url, data, true)
  }
  // 给达人的联系方式快手
  queryReferInfoKs(data) {
    const url = '/open/open/ks-user-relation/refer-info'
    return this.postAjaxByDouYin(url, data, true)
  }

}



// WEBPACK FOOTER //
// ./src/javaApi/douyin.js